import "./App.css";
import { Route, Routes } from "react-router";
import Layout from "./layouts/layout";
import LoginPage from "./features/login/pages/LoginPage";
import ResetPasswordPage from "./features/login/pages/ResetPasswordPage";
import LandingPage from "./features/landing/pages/LandingPage";
import AdminLayout from "./layouts/adminLayout";
import AdmminPage from "./features/admin/pages/adminPage";
import AccountManagerPage from "./features/account_manager/pages/account_manager_page";
import NewAccountPage from "./features/account_manager/pages/new_account_page";
import { AuthProvider } from "./features/login/hooks/useAuth";
import PlaneManagementPage from "./features/planes/pages/PlaneManagementPage";
import PlanFormPage from "./features/planes/pages/PlanFormPage";
import AssignPlanPage from "./features/planes/pages/AssignPlanPage";
import IntegrationsManagementPage from "./features/integrations_provider/pages/IntegrationsManagementPage";
import IntegrationFormPage from "./features/integrations_provider/pages/IntegrationFormPage";
import SetupFormPage from "./features/integration_setup/pages/SetupFormPage";
import UserSettingsPage from "./features/user_settings/pages/UserSettingsPage";
import ClientIntegrationsPage from "./features/client_integrations/pages/ClientIntegrationsPage";
import AccessManagementPage from "./features/integration_access/pages/AccessManagementPage";
import AutomationsManagementPage from "./features/automations/pages/AutomationsManagementPage";
import AutomationEditorPage from "./features/automations/pages/AutomationEditorPage";
import { ToastContainer } from "./shared/components/toast";
import { DialogContainer } from "./shared/components/dialog";
import { BrandingProvider } from "./features/branding/hooks/BrandingProvider";
import BrandingPage from "./features/branding/pages/BrandingPage";
import WorkspacesManagementPage from "./features/workspaces/pages/WorkspacesManagementPage";
import WorkspaceDetailPage from "./features/workspaces/pages/WorkspaceDetailPage";
import WorkspaceDashboardPage from "./features/workspace_dashboards/pages/WorkspaceDashboardPage";

function App() {
  return (
    <BrandingProvider>
      <ToastContainer />
      <DialogContainer />
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<LandingPage />} />
          </Route>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdmminPage />} />
            <Route path="accounts" element={<AccountManagerPage />} />
            <Route path="accounts/new" element={<NewAccountPage />} />
            <Route path="accounts/:id" element={<NewAccountPage />} />
            <Route path="accounts/:id/plan" element={<AssignPlanPage />} />
            <Route path="plans" element={<PlaneManagementPage />} />
            <Route path="plans/new" element={<PlanFormPage />} />
            <Route path="plans/:id" element={<PlanFormPage />} />
            <Route
              path="integrations"
              element={<IntegrationsManagementPage />}
            />
            <Route path="integrations/new" element={<IntegrationFormPage key="new" />} />
            <Route path="integrations/:id" element={<IntegrationFormPage key="edit" />} />
            <Route path="integrations/setups/new" element={<SetupFormPage />} />
            <Route path="integrations/setups/:id" element={<SetupFormPage />} />
            <Route
              path="client_integrations"
              element={<ClientIntegrationsPage />}
            />
            <Route
              path="integrations/access"
              element={<AccessManagementPage />}
            />
            <Route path="settings" element={<UserSettingsPage />} />
            <Route path="branding" element={<BrandingPage />} />
            <Route path="automations" element={<AutomationsManagementPage />} />
            <Route path="automations/new" element={<AutomationEditorPage key="new" />} />
            <Route path="automations/:workflowId" element={<AutomationEditorPage key="edit" />} />
            <Route path="workspaces" element={<WorkspacesManagementPage />} />
            <Route path="workspaces/:workspaceId" element={<WorkspaceDetailPage />} />
            <Route path="workspaces/:workspaceId/dashboard" element={<WorkspaceDashboardPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrandingProvider>
  );
}

export default App;
